import '../utils/fix.cross-origin'
import promise from 'es6-promise';

promise.polyfill();

import 'src/styles/elementui/index.scss';

import LinkVue from 'src/link-components/index';
import LinkTools from '@utils/linktools';
import Emitter from '@utils/emitter';
import {FormOption} from './lnk-form-panel'
import Filters from '@filter';
import Drirectives from '@directive';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';

import lnkAddressCascader from './lnk-address-cascader';
import lnkBigfileUploader from './lnk-bigfile-uploader';
import lnkCalendarGroup from './lnk-calendar-group';
import lnkCombinefilter from './lnk-combinefilter';
import lnkDaterangePicker from './lnk-daterange-picker';
import lnkDlgformPanel from './lnk-form-panel/dlgform-panel';
import lnkExportPick from './lnk-export-pick';
import lnkFeedback from './lnk-feedback';
import lnkForm from './lnk-form';
import lnkFormPanel from './lnk-form-panel';
import lnkFormCell from './lnk-form-panel/form-cell';
import lnkFormCard from './lnk-form-panel/form-card';
import {lnkCrmIframe, lnkDmsIframe} from './lnk-iframe';
import lnkImgviewer from './lnk-imgviewer';
import lnkInputNumber from './lnk-input-number';
import {lnkLov, lnkLovRadio, lnkLovCheck} from './lnk-lov';
import lnkMoreSearch from './lnk-more-search';
import lnkMvg from './lnk-mvg';
import lnkPaginationV from './lnk-pagination-v';
import lnkPanelfolder from './lnk-panelfolder';
import lnkPicklist from './lnk-picklist';
import lnkQuickfilter from './lnk-quickfilter';
import lnkSimpleTable from './lnk-simple-table';
import lnkSingleImgUpload from './lnk-single-img-upload';
import lnkTableDatapanel from './lnk-table-datapanel';
import lnkTableSelectfilter from './lnk-table-selectfilter';
import lnkUploadButtonImg from './lnk-upload-button-img';
import lnkUploadImg from './lnk-upload-img';
import lnkValuelistCascader from './lnk-valuelist-cascader';
import lnkWxImage from './lnk-wx-image';
import lnkWxImageText from './lnk-wx-image-text';

import loadingService from './lnk-loading-modal';
import lnkAuditTrail from './lnk-audit-trail';

const components = [
    lnkAddressCascader,
    lnkBigfileUploader,
    lnkCalendarGroup,
    lnkCombinefilter,
    lnkCrmIframe,
    lnkDmsIframe,
    lnkDaterangePicker,
    lnkDlgformPanel,
    lnkExportPick,
    lnkForm,
    lnkFormPanel,
	lnkFormCell,
	lnkFormCard,
    lnkImgviewer,
    lnkInputNumber,
    lnkLov,
    lnkLovRadio,
    lnkLovCheck,
    lnkMoreSearch,
    lnkMvg,
    lnkPaginationV,
    lnkPanelfolder,
    lnkPicklist,
    lnkQuickfilter,
    lnkSimpleTable,
    lnkSingleImgUpload,
    lnkTableDatapanel,
    lnkTableSelectfilter,
    lnkUploadButtonImg,
    lnkUploadImg,
    lnkValuelistCascader,
    lnkWxImage,
    lnkWxImageText,
];


/* istanbul ignore if */
const LnkVue = {
    install(vue, {processComponent} = {}) {
        if(typeof window!== 'undefined'){
            window.FormOption = FormOption;
        }
        components.forEach((component) => {
            if (!!processComponent) {
                const newComponent = processComponent(component.name, component)
                if (!!newComponent) component = newComponent
            }
            vue.component(component.name, component);
        });
    }
};

const LinkComponents = {
    install(Vue, {LinkVueOption, processComponent, prefixUrl, publicImportUrlprefix} = {}) {
        /* 安装公共过滤器*/
        Vue.use(Filters);

        /* 安装公共指令*/
        Vue.use(Drirectives);

        /* 安装公共组件*/
        Vue.use(LnkVue, {processComponent});

        /* 安装linkTools中原型函数*/
        Vue.use(LinkTools);

        /* 安装消息处理函数*/
        Vue.use(Emitter);

        /* 安装看大图插件*/
        Vue.use(preview);

        /* 安装新版组件 */
        Vue.use(LinkVue, Object.assign({}, LinkVueOption, {processComponent, prefixUrl, publicImportUrlprefix}));

        /* 安装加载动画的相关服务*/
        Vue.use(loadingService);

        /* 安装查看行修改历史的服务 */
        Vue.use(lnkAuditTrail);

        /*安装统一反馈服务*/
        Vue.use(lnkFeedback);

        Vue.prototype.top = window.CURRENT_ORIGIN_TOP;
        Vue.prototype.window = window;
        Vue.prototype.appCtx = window.appCtx;
        Vue.prototype.gotoContentPage = window.gotoContentPage;
    },
};

export default LinkComponents

window.LnkVue = LnkVue;
window.LinkComponents = LinkComponents;
